<template>
    <div class="search">
        <Header></Header>
        <div class="search-box">
            <div class="search-container">
                <input type="text" class="search-input" placeholder="请输入关键字搜索" v-model="searchText" @keyup.enter="search">
                <button class="search-btn" @click="search" :disabled="loading">搜索</button>
            </div>
            <div class="search-result">
                <div v-if="loading" class="loading">
                    <div class="loading-spinner"></div>
                    <div>加载中...</div>
                </div>
                <template v-else>
                    <div class="result-item" @click="goDetail(item)" v-for="item in searchResult" :key="item.id">
                        <h3>{{ item.title }}</h3>
                        <span class="item-time">{{ item.published_time }}</span>
                    </div>
                    <div class="no-result" v-if="searchResult.length == 0">暂无搜索结果</div>
                    <van-pagination v-if="searchResult.length > 0" @change="change()" v-model="currentPage"
                        :total-items="total" :show-page-size="3" force-ellipses />
                </template>
            </div>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
import Vue from 'vue';
import { Pagination } from 'vant';
Vue.use(Pagination);
import { get } from "@/request/http";
import Footer from "@/components/footer.vue";
import Header from "@/components/header.vue";

// 防抖函数
function debounce(fn, delay) {
    let timer = null;
    return function() {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(this, arguments);
        }, delay);
    };
}

export default {
    components: {
        Header,
        Footer,
    },
    data() {
        return {
            currentPage: 1,
            searchText: '',
            searchResult: [],
            page: 1,
            total: 0,
            limit: 10,
            loading: false,
            debounceTimer: null
        }
    },
    // 监听关键字
    watch: {
        searchText(newVal) {
            if (newVal == '') {
                this.searchResult = [];
                this.total = 0;
                this.page = 1;
                return;
            }
            // 如果输入超过2个字符，自动搜索
            if (newVal.length >= 2) {
                this.debouncedSearch();
            }
        }
    },
    created() {
        // 创建防抖版本的搜索函数
        this.debouncedSearch = debounce(this.search, 500);
    },
    methods: {
        goDetail(item) {
            this.$router.push({
                path: "/detail",
                query: {
                    newsId: item.id,
                },
            });
        },
        change() {
            this.page = this.currentPage;
            this.search();
        },
        search() {
            if (!this.searchText) {
                this.$Toast("请输入关键字搜索");
                return;
            }
            this.loading = true;
            get(
                `/gbs/portal/portal/newsPage?limit=${this.limit}&page=${this.page}&title=${this.searchText}`
            ).then((res) => {
                if (res.code !== 0) {
                    this.$Toast.fail(res.msg);
                    this.loading = false;
                    return;
                }
                this.total = res.data.total || 0;
                this.searchResult = res.data.list || res.data;
                this.loading = false;
            }).catch(err => {
                console.error("搜索失败:", err);
                this.$Toast.fail("搜索失败，请稍后重试");
                this.loading = false;
            });
        }
    }
}
</script>

<style scoped lang="scss">
// 主题变量
:root {
    --primary-color: #ba060f;
    --text-color: #333;
    --secondary-text: #999;
    --border-color: #ccc;
    --background-light: #f5f5f5;
    --white: #ffffff;
}

.search {
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    .search-box {
        width: 100%;
        height: calc(100vh - 300px);
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        padding-top: 15px;
        
        .search-container {
            width: 90%;
            max-width: 1000px;
            display: flex;
            margin: 0 auto;
            
            .search-input {
                flex: 1;
                height: 60px;
                border: 1px solid #ccc;
                padding: 0 20px;
                font-size: 20px;
                outline: none;
                box-sizing: border-box;
                
                &::placeholder {
                    color: #999;
                    font-size: 28px;
                }
            }
            
            .search-btn {
                width: 140px;
                height: 60px;
                border: none;
                background-color: #ba060f;
                color: white;
                font-size: 28px;
                margin-left: 10px;
                font-weight: 500;
                cursor: pointer;
                border-radius: 10px;
                
                &:disabled {
                    opacity: 0.7;
                    cursor: not-allowed;
                }
            }
        }

        .search-result {
            width: 90%;
            max-width: 1000px;
            height: calc(100% - 70px);
            overflow-y: auto;
            margin: 20px auto 0;
            background-color: var(--background-light);
            border-radius: 5px;
            padding: 15px;
            box-sizing: border-box;

            .result-item {
                width: 100%;
                height: 70px;
                padding: 10px 15px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px solid var(--border-color);
                cursor: pointer;
                transition: all 0.3s ease;
                box-sizing: border-box;

                &:hover {
                    background-color: rgba(186, 6, 15, 0.05);
                    transform: translateX(5px);
                }

                h3 {
                    width: 75%;
                    font-size: 18px;
                    font-weight: 600;
                    color: var(--text-color);
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin: 0;
                    transition: color 0.3s ease;
                }

                .item-time {
                    width: 25%;
                    font-size: 14px;
                    color: var(--secondary-text);
                    text-align: right;
                    transition: color 0.3s ease;
                }

                &:hover {
                    h3, .item-time {
                        color: var(--primary-color);
                    }
                }
            }

            :deep(.van-pagination) {
                margin-top: 30px;
                padding-bottom: 15px;
                text-align: left !important;
                padding-left: 15px;
                justify-content: flex-start !important;
                display: flex !important;

                .van-pagination__item {
                    color: var(--primary-color);
                    text-align: left !important;
                }

                .van-pagination__item--active {
                    background-color: var(--primary-color);
                    color: var(--white);
                }

                .van-pagination__item:active {
                    background-color: var(--primary-color);
                    color: var(--white);
                }
            }

            .no-result {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 24px;
                color: var(--secondary-text);
            }

            .loading {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                font-size: 18px;
                color: var(--secondary-text);

                .loading-spinner {
                    width: 40px;
                    height: 40px;
                    border: 4px solid var(--primary-color);
                    border-radius: 50%;
                    border-top-color: transparent;
                    animation: spin 1s linear infinite;
                    margin-bottom: 10px;
                }

                @keyframes spin {
                    0% {
                        transform: rotate(0deg);
                    }
                    100% {
                        transform: rotate(360deg);
                    }
                }
            }
        }
    }
}

// 响应式设计
@media screen and (max-width: 768px) {
    .search {
        .search-box {
            .search-container {
                .search-input {
                    height: 60px;
                    padding: 0 15px;
                    font-size: 18px;
                    
                    &::placeholder {
                        font-size: 18px;
                    }
                }
                
                .search-btn {
                    width: 100px;
                    height: 60px;
                    margin-left: 10px;
                    font-size: 24px;
                    border-radius: 10px;
                }
            }
            
            .search-result {
                .result-item {
                    height: 60px;
                    
                    h3 {
                        font-size: 20px;
                        width: 70%;
                    }
                    
                    .item-time {
                        width: 30%;
                        font-size: 16px;
                    }
                }
                
                .no-result {
                    font-size: 20px;
                }
                
                :deep(.van-pagination) {
                    padding-left: 10px;
                    justify-content: flex-start !important;
                }
            }
        }
    }
}
</style>

